const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class Emigration extends Event {
    constructor(){
        super(
            Age.Age2,
            EventNames.Emigration,
            "Each civilization loses half of its discontent workers, rounded up (return them to your yellow bank).",
            {}
        )
    }
}

module.exports = Emigration;